import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";;
import { selectCurrent } from "../../../../../redux/settings/selectors";
import { useSelector } from "react-redux";
import useWindowDimensions from "../../../../../hooks/useWindowsDimensions";
import PageTitle from "../../../../../common/components/PageTitle";
import Thumbnail from "../track-order/thumbnail";
import CustomerAccountSettings from "../../../../../components/customer/AccountSettings";

export default function CustomerTrackOrder() {
    const navigate = useNavigate();
    const { height, width } = useWindowDimensions();
    const [data, getdata] = useState<any>();
    const { register, handleSubmit, clearErrors, formState: { errors } } = useForm();

    const handleChange: any = (event: any, field: string) => {
        getdata({ ...data, [field]: event })
    }

    const trackOrder = () => {
        navigate('/customer/orders/order-tracking', { state: { orderId: data.orderNumber } })
    }

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [])
    return (
        <>
            {width && width < 720 ?
                //  Start - Mobile View  
                <div className={`max-h-screen w-screen mt-20 py-5 px-4`}>
                    <div className="flex flex-col justify-center items-center py-5 w-full">
                        <div className="text-2xl text-qblack font-semibold">
                            Track your Order
                        </div>
                    </div>
                    <div className="flex flex-col justify-around w-full bg-white p-5 items-center rounded">
                        <div className="text-sm text-gray-400 text-start w-full pb-2">
                            Enter your Order Tracking Number:
                        </div>
                        <div className="w-full">
                            <input
                                type="text"
                                {...register('orderNumber', {
                                    required: true,
                                })}
                                className="border p-3 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                placeholder="Track Number"
                                onChange={(event) => {
                                    handleChange(
                                        event.target.value,
                                        'orderNumber'
                                    );
                                }}
                                value={data?.orderNumber}
                            />
                        </div>
                        <div className="flex justify-center items-center py-5">
                            <button onClick={() => { trackOrder() }} className={`bg-primary text-light hover:bg-secondary font-semibold px-4 py-2 rounded`}>
                                Track Now
                            </button>
                        </div>
                        <div className="flex justify-center mt-20">
                            <Thumbnail />
                        </div>
                    </div>
                </div>
                //  End - Mobile View  
                :
                <div className="h-screen flex flex-col justify-between items-stretch bg-white">
                    <div className="flex flex-row">
                        <CustomerAccountSettings />
                        <div className="w-3/4 justity-center items-center">

                            <div className="w-full  rounded-lg  flex flex-col  text-black px-5 pt-20">
                                <div className="flex flex-col items-start justify-between w-full space-y-3">
                                    <div className="flex w-full flex-col items-start justify-between text-xl" >
                                        Track Your Order
                                    </div>
                                    <div className="text-[15px] text-qgraytwo ">
                                        Enter your order tracking number.
                                    </div>

                                </div>
                                <div className="w-full bg-white  px-2 flex items-center">
                                    <div className="w-1/2 ">
                                        <div className="mb-3">

                                            <input
                                                type="text"
                                                {...register('orderNumber', {
                                                    required: true,
                                                })}
                                                className="border-0 px-3 py-3 w-1/2 h-16 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                                placeholder="Track Number"
                                                onChange={(event) => {
                                                    handleChange(
                                                        event.target.value,
                                                        'orderNumber'
                                                    );
                                                }}
                                                value={data?.orderNumber}
                                            />
                                        </div>
                                        <div className="flex justify-start">
                                            <button
                                                onClick={() => { trackOrder() }}
                                                className={`bg-primary text-white hover:bg-[bg-skin-primary] font-semibold px-2 py-2 h-16 w-60 rounded`}
                                            >
                                                Track Now
                                            </button>
                                        </div>
                                    </div>
                                    <div className="flex-1 flex justify-center mt-0">
                                        <Thumbnail />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }</>


    );
}
